import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { AvatarBuilder } from "@/components/AvatarBuilder";
import { MusicPlayer } from "@/components/MusicPlayer";
import ReelsPage from "@/pages/ReelsPage";
import { AuthCallback } from "@/components/AuthCallback";
import { SignInScreen } from "@/components/SignInScreen";
import Home from "@/pages/Home";
import PaymentSuccess, { PaymentCancel } from "@/pages/PaymentSuccess";
import ThoughtsPage from "@/pages/ThoughtsPage";
import OwnerPage from "@/pages/OwnerPage";
import DanganronpaPage from "@/pages/DanganronpaPage";
import ApothecaryPage from "@/pages/ApothecaryPage";
import WitchHatPage from "@/pages/WitchHatPage";
import VillainessPage from "@/pages/VillainessPage";
import MdzsPage from "@/pages/MdzsPage";

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thoughts" element={<ThoughtsPage />} />
        <Route path="/owner" element={<OwnerPage />} />
        <Route path="/danganronpa" element={<DanganronpaPage />} />
        <Route path="/apothecary-diaries" element={<ApothecaryPage />} />
        <Route path="/witch-hat-atelier" element={<WitchHatPage />} />
        <Route path="/inept-villainess" element={<VillainessPage />} />
        <Route path="/master-of-diabolism" element={<MdzsPage />} />
        <Route path="/reels" element={<ReelsPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
      <Footer />
      <CartDrawer />
      <SignInScreen />
    </>
  );
};

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <SmoothScroll />
            <AppRouter />
            <Toaster position="bottom-center" theme="dark" />
            <AvatarBuilder />
            <MusicPlayer />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
